import { StyleSheet } from 'aphrodite';
import { kitTintColor, nameCircles, success } from '../../../web/styles/colors';

export const styleSheet = StyleSheet.create({
	accountStatusGray: {
		backgroundColor: nameCircles,
	},
	accountStatusGreen: {
		backgroundColor: success,
	},
	accountStatusOrange: {
		backgroundColor: kitTintColor,
	},
	accountStatusRed: {
		backgroundColor: '#C22639',
	},
	accountStatusYellow: {
		backgroundColor: '#F0E832',
	},
	adminAccountStatus: {
		borderRadius: '50%',
		display: 'inline-block',
		height: 12,
		marginRight: 15,
		width: 12,
	},
});
